import React, { useState, useEffect } from 'react';

interface SVGProps {
  SvgId?: string;
  svgClass?: string;
  tooltipId?: string;
  tooltipText?: string;
  tooltipPosition?: string;
  handleImageHover?: () => void;
  handleImageClick?: any;
  svgtabIndex?: number;
  id?: string;
  ref?: any;
  show?: boolean;
  action?: boolean;
  useGradient?: boolean;
  onMouseDown?: any;
  style?: any;
}
const SVG: React.FC<SVGProps> = ({
  SvgId,
  svgClass,
  tooltipId,
  tooltipText,
  tooltipPosition,
  handleImageClick,
  handleImageHover,
  svgtabIndex,
  id,
  ref,
  show,
  action,
  useGradient = false,
  onMouseDown,
  style,
}) => {
  useEffect(() => {});

  const gradientId = `gradient-${SvgId}-${
    id || Math.random().toString(36).substring(2, 9)
  }`;

  const showTooltip = () => {
    if (tooltipPosition == 'none') {
      document.getElementById(`${tooltipId}`).style.display = 'none';
    } else {
      document.getElementById(`${tooltipId}`).style.display = '-webkit-box';
    }
  };
  const hideTooltip = () => {
    document.getElementById(`${tooltipId}`).style.display = 'none';
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleImageClick();
    }
  };
  const handleClick = (e) => {
    // Handle click logic here
    if (handleImageClick) {
      handleImageClick(e); // Call the provided onClick handler
    }
  };
  return (
    <span
      className={`${action ? ' ' : 'position-relative'}`}
      id={id}
      title={!show ? tooltipText : ''}
    >
      <svg
        className={`${svgClass}`}
        style={style}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        aria-label={tooltipText}
        onClick={handleClick}
        onMouseOver={handleImageHover}
        onMouseOut={handleImageHover}
        onKeyPress={handleKeyPress}
        tabIndex={svgtabIndex}
        onMouseDown={onMouseDown}
        ref={ref}
      >
        {useGradient && (
           <defs>
           <linearGradient id={gradientId} x1='0%' y1='100%' x2='100%' y2='0%' gradientUnits='userSpaceOnUse'>
             <stop offset='0%' stopColor='#20cbd4' />
             <stop offset='100%' stopColor='#2050ec' />
           </linearGradient>
         </defs>
       )}
       <use
         href={`/asset/icons.svg#${SvgId}`}
         style={useGradient ? {
           stroke: `url(#${gradientId})`,
           fill: `url(#${gradientId})`,
           strokeWidth: '1',
           vectorEffect: 'non-scaling-stroke'
         } : {}}
       />
      </svg>
      {tooltipId && (
        <div
          className={`icon-tooltip text_caption_bold rounded-3 border-grey-1 p-2 text-wrap mw-200 icon-position-${tooltipPosition}`}
          id={`${tooltipId}`}
        >
          <span>{`${tooltipText}`}</span>
        </div>
      )}
    </span>
  );
};

export default SVG;
